import { render, staticRenderFns } from "./PermisionInformation.vue?vue&type=template&id=61ff411e&scoped=true"
import script from "./PermisionInformation.vue?vue&type=script&lang=js"
export * from "./PermisionInformation.vue?vue&type=script&lang=js"
import style0 from "../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PermisionInformation.vue?vue&type=style&index=1&id=61ff411e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ff411e",
  null
  
)

export default component.exports